export function schoolDataReducer(
  state = {
    loading: false,
    result: [],
    error: null
  },
  action
) {
  switch (action.type) {
    case "FETCH_SCHOOLDATA_BEGIN": {
      return { ...state, loading: true };
    }
    case "FETCH_SCHOOLDATA_REJECTED": {
      return { ...state, loading: false, error: action.payload };
    }
    case "FETCH_SCHOOLDATA_FULFILLED": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
